export const NEW_DEPARTMENT_ID = 'NEW_DEPARTMENT_ID';
export function getBlankCompanyDepartment(companyEmailDomain) {
  return {
    name: '',
    userId: null,
    companyEmailDomain,
    _id: NEW_DEPARTMENT_ID
  };
}